export enum OrderTagFilter {
  MOST_POPULAR = 1,
  LEAST_TO_MOST_POINTS = 2,
  MOST_TO_LEAST_POINTS = 3,
}
